// Commission Payable Getters

export const getCommissionPayableList = state => {
  return state.commissionPayableList
}

export const getCommissionPayableInfo = state => {
  return state.commissionPayableInfo
}

export const getCommissionPayableBalanceDetails = state => {
  return state.commissionPayableBalanceDetails
}
